if (!customElements.get("product-carousel")) {
  class ProductCarousel extends HTMLElement {
    connectedCallback() {
      this.carousel = null;
      this.firstImageContainer = this.querySelector(".first-image-container");
      this.carouselContainer = this.querySelector(".product-images-carousel");
      this.firstImage = this.querySelector(".first-product-image");

      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      if (this.firstImage.complete) {
        this.waitForSplide();
      } else {
        this.firstImage.onload = () => this.waitForSplide();
      }
    }

    waitForSplide() {
      if (typeof Splide === "undefined") {
        setTimeout(() => this.waitForSplide(), 100);
        return;
      }
      this.initializeSplide();
    }

    initializeSplide() {
      try {
        this.carousel = new Splide(this.carouselContainer, {
          type: "loop",
          perPage: 1,
          perMove: 1,
          gap: "12px",
          pagination: true,
          arrows: true,
          flickMaxPages: 1,
          preloadPages: 1,
          height: "100%",
        });

        this.carousel.on("mounted", () => {
          this.carouselContainer.classList.add("is-visible");
          setTimeout(() => {
            this.firstImageContainer.classList.add("fade-out");
          }, 300);
        });

        this.carousel.mount();
      } catch (error) {
        console.error("Error initializing Splide:", error);
      }
    }
  }

  customElements.define("product-carousel", ProductCarousel);
}
